import { useMemo } from 'react'
import { Container, Text } from '@pixi/react'
import { Image } from '@slot-nx/core'
import { paragraphStyle, tableTitleStyle } from './textStyle'
import { ParagraphProps } from './Paragraph2'
import { t } from '@slot-nx/core'

export const Paragraph4 = (props: ParagraphProps) => {
  const content = useMemo(() => {
    return (
      <Container y={props.y}>
        <Text
          text={t('gameRules_title3')}
          anchor={[0.5, 1]}
          x={props.width / 2}
          style={tableTitleStyle}
        />
        <Image
          name="bayBar"
          image="bayBar"
          x={props.width / 2}
          y={250}
          anchor={[0.5, 1]}
          width={981}
          height={200}
        />
        <Text
          text={t('gameRules_title3_content_1')}
          x={60}
          y={300}
          style={paragraphStyle}
        />
        <Text
          text={t('gameRules_title3_content_2')}
          x={60}
          y={500}
          style={paragraphStyle}
        />
      </Container>
    )
  }
  , [])
  return content
}
